import angular from 'angular';
import config from '../../ConfigModule/ConfigModule';

export default angular.module('cms.media.has.tile', [config])
    .component('hasMediaTile', {
        template: require('./has-media-tile.html'),
        bindings: {
            model: '<',
            onRemoved: '&'
        },
        controller: function (CONFIG) {
            /** @ngInject */

            this.$onInit = () => {
                this.previewImage = CONFIG.API_PUBLIC + '/image/250x250/' + this.model.media.key;
            };
            this.onRemove = () => {
                if (this.onRemoved) {
                    this.onRemoved();
                }
            }
        }
    })
    .name;



// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/HasMediaTile/HasMediaTile.js